"use client";

import { useSyncExternalStore } from "react";

const subscribe = (listener: () => void) => {
  document.addEventListener("visibilitychange", listener);
  return () => document.removeEventListener("visibilitychange", listener);
};

/**
 * Whether the tab is in front of the planner right now.
 *
 * @returns True while `document.visibilityState` is "visible", re-rendering on each change.
 *   True on the server, where there is no tab to be hidden.
 */
export const useDocumentVisible = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => document.visibilityState === "visible",
    () => true
  );
